import { getFunctionalities } from 'api/functionalities';
import { useQuery } from 'react-query';
import QueryKeys from '../queryKeys';
import { IQueryOptions } from 'interfaces/ui';

function useFunctionalities(options?: IQueryOptions) {
  return useQuery({
    ...options,
    queryFn: async () => {
      const { data } = await getFunctionalities();

      return data.data;
    },
    queryKey: [QueryKeys.getFunctionalities],
  });
}

export default useFunctionalities;
